var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 142,
    width: 102,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 1,
    x: 1,
    height: 400,
    width: 580
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("metadata", {
    transform: "matrix(1.0850693616602172,0,0,1.0850693616602172,0,0) ",
    id: "svg_17"
  }, "image/svg+xml"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#2c5b87",
    id: "svg_16",
    d: "m49.980397,139.057812c-0.311681,-0.757083 -6.786977,-7.08929 -11.423982,-12.843155c-27.472375,-36.474935 -58.101933,-70.365488 -22.336179,-111.55117c15.836313,-15.299977 35.363566,-16.172798 55.438278,-9.041167c56.525209,32.708315 15.600271,86.06606 -11.271506,121.142942l-10.406611,12.29255zm17.003246,-55.910341c37.702225,-26.962934 8.554306,-78.883522 -32.869153,-61.623195c-12.096069,6.44969 -18.097972,17.671862 -18.308174,30.908651c-0.577571,12.876738 6.260901,23.644333 17.097793,30.24038c7.769638,4.228768 11.185291,4.99256 19.982388,4.468372c5.70171,-0.339742 8.987195,-1.270635 14.097146,-3.994208z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#2c5b87",
    fillRule: "nonzero",
    d: "m39.682822,95.670369a49.542485,48.366845 0 1 1 1.234732,0.241046",
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.340164,
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero",
    d: "m44.040725,75.721397a28.643483,23.115801 0 1 1 0.713877,0.115199",
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#000080",
    fillOpacity: 0,
    fillRule: "nonzero",
    d: "m46.186392,125.443062a18.341879,12.939823 0 1 1 0.457134,0.064526",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#1e4972",
    fillRule: "nonzero",
    d: "m42.338672,89.21456a36.809627,37.939875 0 1 1 0.9174,0.189077",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#ffffff",
    fillRule: "nonzero",
    d: "m44.937393,76.109222a24.343085,24.876207 0 1 1 0.606696,0.123976",
    id: "svg_11"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    d: "m93.564103,119.974359",
    opacity: 0.5,
    strokeWidth: 1.5,
    stroke: "#000",
    fill: "#97944B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    d: "m468.241379,263.413793",
    opacity: 0.5,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "#000",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/marker-icon.c14406faadd70337b69ca583cbdfa04e.svg";
export { ForwardRef as ReactComponent };